import './bootstrap';
import '../css/app.css';
import * as Sentry from "@sentry/vue";

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { createPersistedState } from 'pinia-plugin-persistedstate'

import App from '@/App.vue'
import router from "./router.js"
import { useAuthStore } from "@/stores/auth.js";

const pinia = createPinia();
pinia.use(createPersistedState({}));

import PrimeVue from 'primevue/config';
import ConfirmationService from "primevue/confirmationservice";
import DialogService from "primevue/dialogservice";
import ToastService from 'primevue/toastservice';
import Wind from '@/presets/Wind';
import Ripple from 'primevue/ripple';
import Tooltip from 'primevue/tooltip';

const app = createApp(App)

if (import.meta.env.VITE_APP_ENV === 'production' || import.meta.env.VITE_APP_ENV === 'staging') {
  Sentry.init({
    app,
    dsn: "https://dd8ee8f952a3a6971c0e268f0574a7cf@o4507697516445696.ingest.de.sentry.io/4507699066241104",
    integrations: [
      Sentry.browserTracingIntegration({router}),
    ],

    tracePropagationTargets: [import.meta.env.VITE_BASE_URL],
    tracesSampleRate: 0,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,

    release: APPLICATION_VERSION,
    environment: import.meta.env.VITE_APP_ENV || APPLICATION_ENV,
  });
  Sentry.setTag('codebase', 'js');
}

app.use(ConfirmationService);
app.use(DialogService);
app.use(ToastService);
app.use(PrimeVue, {
  unstyled: true,
  pt: Wind,
  ripple: true,
});
app.use(pinia);
app.use(router);
app.directive('ripple', Ripple);
app.directive('tooltip', Tooltip);

app.mount("#app")
app.config.globalProperties.$auth = useAuthStore();
import dayjs from "dayjs";
import AdvancedFormat from 'dayjs/plugin/advancedFormat';
import LocalizedFormat from 'dayjs/plugin/localizedFormat';
import RelativeTime from 'dayjs/plugin/relativeTime';
dayjs.extend(AdvancedFormat);
dayjs.extend(LocalizedFormat);
dayjs.extend(RelativeTime);
app.config.globalProperties.$dateService = dayjs;

import 'chartjs-adapter-dayjs-4/dist/chartjs-adapter-dayjs-4.esm';
import { getChartLabelPlugin } from 'chart.js-plugin-labels-dv';

import { Chart as ChartJS } from 'chart.js'
ChartJS.register(getChartLabelPlugin())

import i18n from "@/i18n.js";
app.use(i18n);